export const feedCountInArray = (arr, selectedTopics) => {
    let count = 0;
    arr.forEach((val) => {
        if(selectedTopics.includes(val.topic.id)){
          count += val.count;
        }
    });
    return count;
}